import { FC } from "react";
import { PreferredValueDraft, rawValueToNumber } from "../utils";
import { NamedNumberic } from "../../../ui/layout/molecules/NamedNumberic";
import { NamedTextInput } from "../../../ui/layout/molecules/NamedTextInput";
import { NoDataMessage } from "../../../ui/layout/detailedPages/NoDataMessage";
import {
  DETAILS_SECTION_STYLES,
  SUB_HEADER_STYLES,
} from "../../../ui/layout/detailedPages/styles";
import { FieldsGroup } from "../../../ui/layout/organisms/SlideOver/SlideOverFixedLayouts/SlideOverFieldsGroups/FieldsGroup";
import { AddComponentsButton } from "../../../ui/layout/organisms/SlideOver/components/AddComponentsButton";
import { WeightNumberInput } from "./WeightNumberInput";
import { PureVoidFunc, VoidFunc } from "../../../helpers/functions/types";

export type { PreferredValueDraft };

export const PreferredValuesList: FC<{
  drafts: PreferredValueDraft[];
  colType: "number" | "string";
  onAdd: PureVoidFunc;
  onRemove: VoidFunc<number>;
  onUpdate: (patch: Partial<PreferredValueDraft>, i: number) => void;
}> = ({ drafts, colType, onAdd, onRemove, onUpdate }) => {
  return (
    <section className={DETAILS_SECTION_STYLES}>
      <header className="flex h-fit items-center justify-between">
        <h3 className={SUB_HEADER_STYLES}>Preferred values</h3>
        <AddComponentsButton
          valueTitle="preferredValues"
          buttonText="Add"
          onClick={onAdd}
          canAddExtraComponent={true}
        />
      </header>

      {drafts.length === 0 && (
        <NoDataMessage>No preferred values configured</NoDataMessage>
      )}

      {drafts.map((draft, i) => (
        <FieldsGroup
          key={i}
          handleRemove={() => onRemove(i)}
        >
          <WeightNumberInput
            value={draft.weight}
            onChange={(v) => onUpdate({ weight: v }, i)}
          />
          {colType === "number" ? (
            <NamedNumberic
              title="Value"
              value={rawValueToNumber(draft.rawValue)}
              onChange={(target) => onUpdate({ rawValue: target.value }, i)}
            />
          ) : (
            <NamedTextInput
              title="Value"
              value={draft.rawValue}
              onChange={(target) => onUpdate({ rawValue: target.value }, i)}
            />
          )}
        </FieldsGroup>
      ))}
    </section>
  );
};
